import BotReportEditHeader from './BotReportEditHeader';
import withAuthorizer from 'components/ui/withAuthorizer';
import withContentLoader from 'components/ui/withContentLoader';

import BotReportApi from 'api/bot-report';

import BotReportEditInfo from 'components/bots/reports/BotReportEditInfo';
import BotReportEditColumns from 'components/bots/reports/BotReportEditColumns';
import BotReportEditFilters from 'components/bots/reports/BotReportEditFilters';

import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useState } from 'react';

import { Resources } from 'helpers/ResourceHelper';
import NotificationHelper from 'helpers/NotificationHelper';

const BotReportPage = ({ data = {} }) => {
  const { t } = useTranslation();
  const [saving, setSaving] = useState(false);
  const [filters, setFilters] = useState([]);
  const [columns, setColumns] = useState(data.columns || []);

  const { schemas = [] } = data;
  const work_object_schemas = schemas.find(item => item.id === 'work_object') || {};
  const schema = work_object_schemas.schema || {};
  const properties = schema.properties || {};

  properties.created_at = { title: t('columns.created_at'), format: 'date' };
  properties.updated_at = { title: t('columns.updated_at'), format: 'date' };
  properties.status = { title: t('columns.status') };

  const handleClickSave = async e => {
    setSaving(true);

    try {
      const name = document.querySelector('#inputName').value;

      if (!name) {
        alert('Por favor, preencha o nome do relatório.');
        return;
      }

      const description = document.querySelector('#inputDescription').value;

      await BotReportApi.update(data.id, { name, description, columns, filters });
    } catch (error) {
      NotificationHelper.snack(t('messages.unexpected_error'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <BotReportEditHeader report={data} saving={saving} onClickSave={handleClickSave} />

      <div className="container mt-4">
        <div className="row">
          <div className="col-md-12 mb-4">
            <h6 className="mb-3 col-md-8 text-muted text-uppercase">{t('keys.filters')}</h6>
            <BotReportEditFilters report={data} schema={schema} onChange={setFilters} />
          </div>

          <div className="col-md-4 mb-4">
            <h6 className="mb-3 col-md-8 text-muted text-uppercase">{t('keys.data')}</h6>
            <BotReportEditInfo report={data} schema={schema} onChange={setFilters} />
          </div>

          <div className="col-md-8 mb-4">
            <h6 className="mb-3 col-md-8 text-muted text-uppercase">{t('keys.columns')}</h6>
            <BotReportEditColumns report={data} schema={schema} onChange={setColumns} />
          </div>
        </div>
      </div>
    </>
  );
};

const Container = () => {
  const { reportId } = useParams();

  const fetchData = async () => BotReportApi.get(reportId);
  const Component = withContentLoader(BotReportPage, { name: ['botreport', reportId], fetchData });
  return <Component reportId={reportId} />;
};

export default withAuthorizer(Container, [Resources.BOT_MANAGER]);
